import React, { Component  } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable, MDBCard, MDBCardBody, MDBCardImage, MDBCardTitle, MDBCardText } from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card,Tooltip  } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';

import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import Table from '@material-ui/core/Table';  
import { CSVLink, CSVDownload } from "react-csv";
import ReactExport from "react-export-excel";
//import ModelDescription from './ModelDescription';
import { api, URL } from '../../api';
import Modelshowstudent from './Modelshowstudent';
import Moment from 'react-moment';
//import ModelRegister from './ModelRegister';


export default class Teachershortterm extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          modal: false,
         
          type:'1',
        
          year:'2564',
          search: '',

          Curriculum:[],
          Studentcb_ID:'',
          Citizen:'',


   
          Course_ID:'',
          Course_Name_TH:'',
          Course_Name_En:'',
          Course_Credit:'',
          Course_Year:'',
          Course_T_Hour:'',
          Course_Detail_TH:'',
          Course_Detail_EN:'',

          pagination: {
            current: 1,
            pageSize: 20,
          },


          UserUPDATE:'',
          datsShortcourse:[],

        };
       
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.time = this.time.bind(this);
        this.sentpdf = this.sentpdf.bind(this);
       
        this.refreshPage = this.refreshPage.bind(this);
        this.onChange = this.onChange.bind(this);


        this.getCurriculumopen = this.getCurriculumopen.bind(this);
        this.getCitizenstu = this.getCitizenstu.bind(this);
        this.linkto = this.linkto.bind(this);
        
      }


      onChange(value) {
        
           const Courseselect = this.state.Course.filter( ({ Course_ID }) => Course_ID.substring(0, 7) === value.substring(0, 7) );
         //  const idemp = value;
         //  console.log(Courseselect[0].Course_ID);
           this.setState({ Course_ID : Courseselect[0].Course_ID.substring(0, 7) });
           this.setState({ Course_Name_TH : Courseselect[0].Course_Name_TH });
           this.setState({ Course_Name_En : Courseselect[0].Course_Name_En });
           this.setState({ Course_Credit : Courseselect[0].Course_Credit });
           this.setState({ Course_Year : Courseselect[0].Course_Year });
           this.setState({ Course_T_Hour : Courseselect[0].Course_T_Hour });
           this.setState({ Course_Detail_TH : Courseselect[0].Course_Detail_TH });
           this.setState({ Course_Detail_EN : Courseselect[0].Course_Detail_EN });

           this.getCurriculumopen()

        }

        //ดึงหลักสูตรที่เปิดสอน
        getCurriculumopen() {
          setTimeout(() => {
             //ภายใน
             api.get('index/getCurriculumopen/'+this.state.Course_ID)
             .then(res => {
             //  console.log(res);
             //  this.setState({ bankname: res.data, loading: false })
               this.setState({ Curriculumopen: res.data})
             }) 
           }, 0);
      }


      
      linkto(event) {
          console.log(event.target.value)
          const id = event.target.value;

          window.location.href = '/creditbank/Teachercuriculum/'+id;
          // setTimeout(() => {
          //    //ภายใน
          //    api.get('index/getCurriculumopen/'+this.state.Course_ID)
          //    .then(res => {
          //    //  console.log(res);
          //    //  this.setState({ bankname: res.data, loading: false })
          //      this.setState({ Curriculumopen: res.data})
          //    }) 
          //  }, 0);
      }

  

      getCitizenstu() {
        setTimeout(() => {
           //ภายใน
           api.get('index/getCitizenstu/'+localStorage.getItem('Studentcb_ID'))
           .then(res => {
           //  console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ Citizen: res.data[0].Studentcb_Citizen_ID})
           }) 
         }, 0);
       }


      sentpdf() {
        setTimeout(() => {
       //   window.open('https://e-student.kpru.ac.th/vaccinekpru/vaccinepdf/report/tess.php?stu='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }

 
         onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          refreshPage() {
            window.location.reload(false);
          }


          componentDidMount(){
           
           // this.setState({ Studentcb_ID:localStorage.getItem('Studentcb_ID')}) 
            this.setState({ UserUPDATE:localStorage.getItem('Citizen_ID')})   

            if (localStorage.getItem('Citizen_ID') == null) {
               
              window.location.href = 'https://e-student.kpru.ac.th/creditbank'
               
            } else {
        
            }
                      api.get('index/getShortcourseforuser/'+ localStorage.getItem('Citizen_ID'),
                   //     Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                      {headers: {
                        // Authorization: 'Bearer ' + localStorage.getItem('myData')
                      }
                      })
                      //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                      .then(res => {
                       
                          const datsShortcourse = res.data;
                          this.setState({ datsShortcourse });
                      })    
               // this.getCitizenstu()  ;   
          }


          getColumnSearchProps = dataIndex => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters , filters}) => (
              <div style={{ padding: 8 }}>
                <Input
                  ref={node => {
                    this.searchInput = node;
                  }}
                  placeholder={`ค้นหา`}
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                  style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                  type="primary"
                  onClick={() => this.handleSearch(selectedKeys, confirm)}
                  icon=""
                  size="small"
                  style={{ width: 90, marginRight: 8 }}
                >
                  ค้นหา
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  ยกเลิก
                </Button>
              </div>
            ),
            filterIcon: filtered => (
              <SearchOutlined />
            ),
        
            onFilter: (value, record) =>
              record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => this.searchInput.select());
              }
            },
        
            
            render: text => (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ),
          });
        
          handleSearch = (selectedKeys, confirm) => {
            confirm();
            this.setState({ searchText: selectedKeys[0] });
          };
        
          handleReset = clearFilters => {
            clearFilters();
            this.setState({ searchText: '' });
          };
                
          clearFilters = () => {
            this.setState({ filteredInfo: null });
          };
        
        
          clearAll = () => {
            this.setState({
              filteredInfo: null,
              sortedInfo: null,
            });
          };


    render() {

     
      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const {  pagination } = this.state;
     
      
      const { Option } = Select;
     // const newDate = moment(new Date()).format("DD/MM/YYYY");
     // const newDate = new Date("MM/DD/YYYY");
     const date = new Date();
     const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
     const dates = year+"-"+month+"-"+day ;
     // console.log(dates);
     const text = <span>หลักสูตรจะแสดงเมื่อมีการเพิ่มผู้สอนในหลักสูตร </span>;



                //ชุดตาราง
                const data = {
                    columns: [
                      {
                        label: '#',
                        field: 'list',
                        sort: 'list',
                        width: 150
                      },
                      {
                        label: 'banner',
                        field: 'Shortcourse_banner',
                        sort: 'Shortcourse_banner',
                        width: 150
                      },
                      {
                        label: 'เทอม',
                        field: 'Shortcourse_Team',
                        sort: 'Shortcourse_Team',
                        width: 150
                      },
                      {
                        label: 'รหัสวิชาหลัก',
                        field: 'Shortcourse_Course_ID',
                        sort: 'Shortcourse_Course_ID',
                        width: 270
                      },
                      {
                        label: 'ชื่อหลักสูตรภาษาไทย',
                        field: 'Shortcourse_Nameshortterm_TH',
                        sort: 'Shortcourse_Nameshortterm_TH',
                        width: 200
                      },
                      {
                        label: 'ชื่อหลักสูตรภาษาอังกฤษ',
                        field: 'Shortcourse_Nameshortterm_EN',
                        sort: 'Shortcourse_Nameshortterm_EN',
                        width: 100
                      },
                      {
                        label: 'จำนวนหน่วยกิต',
                        field: 'Shortcourse_Credit',
                        sort: 'Shortcourse_Credit',
                        width: 150
                      },
                      {
                        label: 'จำนวนชั่วโมง',
                        field: 'Shortcourse_Numch',
                        sort: 'Shortcourse_Numch',
                        width: 150
                      },
                      {
                        label: 'จำนวนลงทะเบียน',
                        field: 'Shortcourse_Numregis',
                        sort: 'Shortcourse_Numregis',
                        width: 150
                      },
                      {
                        label: 'วันเริ่ม',
                        field: 'Shortcourse_Timestart',
                        sort: 'Shortcourse_Timestart',
                        width: 150
                      },
                      {
                        label: 'วันสิ้นสุด',
                        field: 'Shortcourse_Timeend',
                        sort: 'Shortcourse_Timeend',
                        width: 150
                      },
                      {
                        label: 'จัดการ',
                        field: 'Shortcourse_edit',
                        sort: 'Shortcourse_edit',
                        width: 150
                      }
      
      
                    ],
          
                    rows: [...this.state.datsShortcourse.map((data, i) => (
                      {
                         list: <>{i+1}</>,
                         Shortcourse_banner: <></>,
                         Shortcourse_Team: <>{data.Shortcourse_Team}</>,
                         Shortcourse_Course_ID: <>{data.Shortcourse_Course_ID}</>,
                         Shortcourse_Nameshortterm_TH: <>{data.Shortcourse_Nameshortterm_TH}</>,
                         Shortcourse_Nameshortterm_EN: <>{data.Shortcourse_Nameshortterm_EN}</>,
                         Shortcourse_Credit: <>{data.Shortcourse_Credit}</>,
                         Shortcourse_Numch: <>{data.Shortcourse_Numch}</>,
                         Shortcourse_Numregis: <>{data.Shortcourse_Numregis}</>,
                         Shortcourse_Timestart: <>{data.Shortcourse_Timestart}</>,
                         Shortcourse_Timeend: <>{data.Shortcourse_Timeend}</>,
                         Shortcourse_edit: <><MDBBtn color="mdb-color">MDB</MDBBtn><MDBBtn color="mdb-color">EDIT</MDBBtn><MDBBtn color="mdb-color">ผู้สมัคร</MDBBtn></> ,
                      
                      }
                     ))]
                    
                
                };
          
                const persons = <MDBDataTable
               // searching ={true}
                searchLabel="ค้นหา ชื่อหลักสูตร"
                striped
                bordered
                small 
                entries={20}
               // entriesOptions={["10", "20"]}
                order={["age", "desc"]}
                data={data}
                entriesLabel="จำนวนที่แสดง "
                infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
                paginationLabel={["ย้อนกลับ", "ถัดไป"]}
                responsive 
                sortRows={['random']}
          />
          //ชุดตาราง 




       
        return (
            <MDBContainer fluid>
             
    
        {/* <CSVLink data={data}>Download EXCEL</CSVLink> */}
        <Card type="inner" style={{ marginTop: 16 }}  title={<h4><MDBIcon icon="list-alt" /> หลักสูตรระยะสั้น</h4> } extra={<a href="#"><p>อาจารย์{localStorage.getItem('name')}</p></a>} >

                        <Breadcrumb>
                          <Breadcrumb.Item>หลักสูตรระยะสั้น </Breadcrumb.Item>
                        </Breadcrumb>
                        <br/>

                 <MDBRow>
                        <MDBCol sm="12">
                            <MDBJumbotron fluid>
                            <MDBContainer fluid>
                            <h2 className="display-5 deep-purple-text text-center">หลักสูตรระยะสั้น   
                                   
                            </h2> 
                            <p className="text-right">
                               <Tooltip placement="top" title={text} color="orange">
                                        <MDBIcon icon="question-circle" size="lg" />
                                    </Tooltip> 
                            </p>
                          
                            {persons}

                            </MDBContainer>
                            </MDBJumbotron>    
                      
                        </MDBCol>
                 </MDBRow>

        </Card>
            </MDBContainer>
        )
    }
}
